import { actionTypes } from "./constants";

export const fetchFlagsRequest = (stateConfig = null) => ({
  type: actionTypes.FETCH_FLAGS_REQUEST,
  payload: stateConfig
});

export const fetchFlagsSuccess = payload => ({
  type: actionTypes.FETCH_FLAGS_SUCCESS,
  payload
});

export const fetchFlagsFailure = error => ({
  type: actionTypes.FETCH_FLAGS_FAILURE,
  payload: error
});
